import { LIVE_STATUS, staticUiLabels } from '../../../../../common/constants';

/**
 * Utility function to get live video labels with fallback to static labels
 * @param {Object} uiLabels - Dynamic UI labels from API
 * @returns {Object} Live video labels with fallback support
 */
export const getLiveVideoLabels = (uiLabels = {}) => {
  return {
    GO_LIVE_BUTTON:
      uiLabels.LIVE_VIDEO_GO_LIVE_BUTTON?.value ||
      staticUiLabels.LIVE_VIDEO_GO_LIVE_BUTTON,
    STARTING_SOON_TITLE:
      uiLabels.LIVE_VIDEO_STARTING_SOON_TITLE?.value ||
      staticUiLabels.LIVE_VIDEO_STARTING_SOON_TITLE,
    STREAM_ENDED_TITLE:
      uiLabels.LIVE_VIDEO_STREAM_ENDED_TITLE?.value ||
      staticUiLabels.LIVE_VIDEO_STREAM_ENDED_TITLE,
    REPLAY_COMING_SOON_TITLE:
      uiLabels.LIVE_VIDEO_REPLAY_COMING_SOON_TITLE?.value ||
      staticUiLabels.LIVE_VIDEO_REPLAY_COMING_SOON_TITLE,
    PROCESSING_MESSAGE_TEXT:
      uiLabels.LIVE_VIDEO_PROCESSING_MESSAGE_TEXT?.value ||
      staticUiLabels.LIVE_VIDEO_PROCESSING_MESSAGE_TEXT,
    THANK_YOU_TEXT:
      uiLabels.LIVE_VIDEO_THANK_YOU_TEXT?.value ||
      staticUiLabels.LIVE_VIDEO_THANK_YOU_TEXT,
    WATCH_REPLAY_BUTTON:
      uiLabels.LIVE_VIDEO_WATCH_REPLAY_BUTTON?.value ||
      staticUiLabels.LIVE_VIDEO_WATCH_REPLAY_BUTTON,
    LIVE_VIDEO_PAUSED_TITLE:
      uiLabels.LIVE_VIDEO_PAUSED_TITLE?.value ||
      staticUiLabels.LIVE_VIDEO_PAUSED_TITLE,
    LIVE_VIDEO_PAUSED_SUBTITLE:
      uiLabels.LIVE_VIDEO_PAUSED_SUBTITLE?.value ||
      staticUiLabels.LIVE_VIDEO_PAUSED_SUBTITLE,
    [LIVE_STATUS.PENDING]:
      uiLabels.LIVE_VIDEO_PENDING_LABEL?.value ||
      staticUiLabels.LIVE_VIDEO_PENDING_LABEL,
    [LIVE_STATUS.LIVE]:
      uiLabels.LIVE_VIDEO_LIVE_LABEL?.value ||
      staticUiLabels.LIVE_VIDEO_LIVE_LABEL,
    [LIVE_STATUS.VOD_PROCESSING]:
      uiLabels.LIVE_VIDEO_VOD_PROCESSING_LABEL?.value ||
      staticUiLabels.LIVE_VIDEO_VOD_PROCESSING_LABEL,
    [LIVE_STATUS.COMPLETED]:
      uiLabels.LIVE_VIDEO_COMPLETED_LABEL?.value ||
      staticUiLabels.LIVE_VIDEO_COMPLETED_LABEL
  };
};

export const getLiveBadgeText = (status, uiLabels = {}) => {
  const labels = getLiveVideoLabels(uiLabels);
  return labels[LIVE_STATUS.LIVE];
};

export default getLiveVideoLabels;
